import React from 'react';
import './row.scss';
export var Row = function (_a) {
    var children = _a.children, mb = _a.mb, relativeRow = _a.relativeRow;
    var rowClasses = 'c-row';
    if (mb) {
        rowClasses += " u-mb-".concat(mb);
    }
    if (relativeRow) {
        rowClasses += " c-row__relative-row";
    }
    return React.createElement("div", { className: rowClasses }, children);
};
